module.exports = __webpack_public_path__ + "img/BE0445048470.8c2b9291.svg";